import { ActionType, getType } from 'typesafe-actions';

import * as Action from '../actions/LayoutAction';

const defaultState = {
  productCreateVisible: false,
};
export default function constant(
  state: LayoutState = defaultState,
  action: ActionType<typeof Action>
): LayoutState {
  switch (action.type) {
    case getType(Action.toggleProductCreate):
      return { ...state, productCreateVisible: !state.productCreateVisible };
    default:
      return state;
  }
}
